import { Atom } from 'AppReact';
import styled, { css } from 'styled-components';

const template = styled.span`
  ${({ theme }) => css`
    max-width: 300px;
    min-width: 200px;
    position: absolute;
    padding: 10px;
    bottom: 20px;
    left: 50%;
    -webkit-transform: translateX(-50%);
    transform: translateX(-50%);
    text-align: center;
    background: ${`${theme?.colour?.secondary}E6`};
    color: white;
    font-size: 12px;
    border-radius: 8px;
  `}
`;

export default Atom({ type: 'label', dataType: 'string', template })